import React, {useEffect} from "react";
import { Helmet } from "react-helmet";
import { refreshAccessToken } from "./aws/auth";

// Screens
import Main from "./Main.jsx";

export default function App() {
    useEffect(() => {
        const interval = setInterval(() => {
            refreshAccessToken();
        }, 55 * 60 * 1000); // Refresh every 55 minutes

        return () => clearInterval(interval);
    }, []);
    return (
    <>
      <Helmet>
        {/* Georgia is a system font, so no Google Fonts import needed */}
      </Helmet>
      <Main />
    </>
    );
}

